import { Box, Typography } from '@mui/material';
import { IconButton } from '@sweep-io/sweep-design';
import { ArrowLeft } from '@sweep-io/sweep-design/dist/icons/ArrowLeft';
import { useUserDialogContext } from '../user-dialog/UserDialogContext';
import { microsoftTeamsLogoUrl } from '../../common/connect-sweep-to/integrationIcons';

export const TeamsInstallationHeader = () => {
  const { setIsTeamsInstallationOpen } = useUserDialogContext();

  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mr: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <IconButton
            size="tiny"
            variant="flat"
            onClick={() => {
              setIsTeamsInstallationOpen(false);
            }}
          >
            <ArrowLeft size="medium" />
          </IconButton>
          <img src={microsoftTeamsLogoUrl} width={24} height={24} alt="Microsoft Teams" />
          <Typography variant="h3">Manage Teams</Typography>
        </Box>
      </Box>
    </>
  );
};
